import { render } from "./FormAddDrawListLottery.vue?vue&type=template&id=61ded8f6"
import script from "./FormAddDrawListLottery.vue?vue&type=script&lang=js"
export * from "./FormAddDrawListLottery.vue?vue&type=script&lang=js"

import exportComponent from "/home/atom/Works/renny/rotto-web-admin/Front-End/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__